import React from 'react';
import { Link } from 'react-router-dom';

const Wordmark = ({ to = '/', className = '', onClick }) => (
  <Link
    to={to}
    onClick={onClick}
    className={`inline-block font-[700] tracking-[-0.03em] text-[1.2rem] text-fg hover:opacity-80 transition-opacity ${className}`}
  >
    Vegetablah
  </Link>
);

export default Wordmark;
